module.exports = __webpack_public_path__ + "static/media/submission.439d9000.svg";